// web-admin/src/services/workflowService.js
import axios from "axios";

// Use REACT_APP_API_URL1 which typically points to the base /api endpoint
// fallback to a cleaned version of REACT_APP_API_URL if needed
const API_URL = process.env.REACT_APP_API_URL1 || 
                (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace("/web-auth", "") : "http://localhost:3000/api");

const getHeaders = () => {
  const tenant = localStorage.getItem("tenant") || "";
  return {
    "X-Tenant": tenant,
  };
};

export const fetchWorkflows = async () => {
  try {
    const res = await axios.get(`${API_URL}/workflows`, { 
      withCredentials: true,
      headers: getHeaders()
    });
    return res.data;
  } catch (err) {
    console.error("fetchWorkflows error:", err);
    return { success: false, workflows: [] };
  }
};

export const createWorkflowStep = async (data) => {
  try {
    const res = await axios.post(`${API_URL}/workflows`, data, { 
      withCredentials: true,
      headers: getHeaders()
    });
    return res.data;
  } catch (err) {
    console.error("createWorkflowStep error:", err);
    return { success: false };
  }
};

export const updateWorkflowStep = async (id, data) => {
  try {
    const res = await axios.put(`${API_URL}/workflows/${id}`, data, { 
      withCredentials: true,
      headers: getHeaders()
    });
    return res.data;
  } catch (err) {
    console.error("updateWorkflowStep error:", err);
    return { success: false };
  }
};

export const deleteWorkflowStep = async (id) => {
  try {
    const res = await axios.delete(`${API_URL}/workflows/${id}`, { 
      withCredentials: true,
      headers: getHeaders()
    });
    return res.data;
  } catch (err) {
    console.error("deleteWorkflowStep error:", err);
    return { success: false };
  }
};
